/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusKundeModulesDto } from '../../models/lexplus-kunde-modules-dto';

export interface KundeModulesControllerGetKundeModulesV1$Params {
}

export function kundeModulesControllerGetKundeModulesV1(http: HttpClient, rootUrl: string, params?: KundeModulesControllerGetKundeModulesV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusKundeModulesDto>> {
  const rb = new RequestBuilder(rootUrl, kundeModulesControllerGetKundeModulesV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusKundeModulesDto>;
    })
  );
}

kundeModulesControllerGetKundeModulesV1.PATH = '/v1/kunden/modules';
